import { render, staticRenderFns } from "./DashboardPois.vue?vue&type=template&id=39ee6e8d&scoped=true"
import script from "./DashboardPois.vue?vue&type=script&lang=js"
export * from "./DashboardPois.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ee6e8d",
  null
  
)

export default component.exports